import { useTranslation } from 'react-i18next'

import { CountryMultiSelect } from './AddressFormStepConfig'
import type { RuntimeStepConfig } from '../types'

interface AccessRestrictionsStepConfigProps {
  value: RuntimeStepConfig['accessSettings']
  onChange: (config: RuntimeStepConfig['accessSettings']) => void
}

export function AccessRestrictionsStepConfig({ value, onChange }: AccessRestrictionsStepConfigProps) {
  const { t } = useTranslation()

  const blockedCountries = value?.blockedCountries

  const updateBlocked = (next: string[] | undefined) => {
    onChange(
      next && next.length > 0
        ? { ...value, blockedCountries: next }
        : undefined,
    )
  }

  return (
    <div className="space-y-4">
      <CountryMultiSelect
        label={t('stepEditor.accessRestrictions.blockedCountries')}
        description={t('stepEditor.accessRestrictions.blockedCountriesDescription')}
        value={blockedCountries ?? []}
        onChange={updateBlocked}
        emptyLabel={t('stepEditor.accessRestrictions.noCountriesBlocked')}
      />
    </div>
  )
}
